import useWindowDimensions from '../../hooks/useWindowDimensions';
import AppNavBarLayout from './AppNavBarLayout';
import Logo from '../Logo';
import Link from 'next/link';
import PropertySearch from '../search/PropertySearch';
import LoginPopover from '../LoginPopover';
import { useSearch } from '../../contexts/SearchContext';
import NoSsr from 'react-no-ssr';

type Props = {};

export default function MapNavBar({}: Props) {
  const { isMobile } = useWindowDimensions();
  const { openSearchFilterModal } = useSearch();

  if (isMobile) {
    return (
      <AppNavBarLayout className="border-b-0">
        <Link
          href={'/m'}
          legacyBehavior={false}
          className="flex items-center justify-start flex-1 mr-4"
        >
          <Logo size={24} showText={false} />
        </Link>

        <div className="w-full md:mx-4">
          <PropertySearch />
        </div>
      </AppNavBarLayout>
    );
  } else {
    return (
      <AppNavBarLayout className="border-b-0">
        <Link href={'/m'} legacyBehavior={false} className="flex items-center">
          <Logo size={24} showText={true} />
        </Link>
        <div
          className="w-full ml-4 md:mx-4 lg:mx-40 xl:mx-64"
          style={{ maxWidth: '60rem' }}
        >
          <PropertySearch />
        </div>
        <div className="flex flex-row space-x-4">
          <NoSsr>
            <LoginPopover />
          </NoSsr>
        </div>
      </AppNavBarLayout>
    );
  }
}
